import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, parseError } from '../api/client';
import { meOptions } from './queries';
import type { Me } from './types';

export interface LoginRequest { email: string; password: string }

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: LoginRequest) =>
      api.post('auth/login', { json: body }).json<Me>(),
    onSuccess: (me) => {
      // Prime the cache so the next /me query is instant.
      qc.setQueryData(meOptions().queryKey, me);
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('auth/logout').then(() => undefined),
    onSuccess: () => {
      qc.clear();
    },
  });
}

export { parseError };
